<template>
  <div class="app" :class="weatherClass">
    <div class="centered-text" v-if="!searchPerformed">
      <div class="card">
        <div class="loader">
          <p>Get the weather of</p>
          <div class="words">
            <span class="word"></span>
            <span class="word">City</span>
            <span class="word">Town</span>
            <span class="word">State</span>
            <span class="word">Country</span>
            <span class="word"></span>
          </div>
        </div>
      </div>
    </div>
    <main>
      <div class="search-box">
        <input type="text" class="search-bar" placeholder="Search..." v-model="query" @keypress="fetchWeather" />
      </div>

      <div class="weather-wrap" v-if="typeof weather.main != 'undefined'">
        <div class="location-box">
          <div class="location">{{ weather.name }}, {{ weather.sys.country }}</div>
          <div class="date">{{ dateBuilder() }}</div>
        </div>

        <div class="weather-box">
          <div class="temp">{{ Math.round(weather.main.temp) }}°c</div>
          <div class="weather">{{ weather.weather[0].main }}</div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      api_key: '320eec9d8d5188955d01f8ef0e89d175',
      url_base: 'https://api.openweathermap.org/data/2.5/',
      query: '',
      weather: {},
      searchPerformed: false, // Add this flag
      errorMessage: '' // Add this property to store error messages
    }
  },
  computed: {
    weatherClass() {
      if (typeof this.weather.main != 'undefined') {
        if (this.weather.main.temp >= 15 && this.weather.main.temp <= 25) {
          return 'warm';
        } else if (this.weather.main.temp < 14) {
          return 'cold';
        } else if (this.weather.main.temp > 25) {
          return 'hot';
        }
      }
      return '';
    }
  },
  methods: {
    fetchWeather(e) {
      if (e.key == "Enter") {
        fetch(`${this.url_base}weather?q=${this.query}&units=metric&APPID=${this.api_key}`)
          .then(res => {
            if (!res.ok) {
              throw new Error('Network response was not ok');
            }
            return res.json();
          })
          .then(this.setResults)
          .catch(error => {
            console.error('There has been a problem with your fetch operation:', error);

          });
        this.searchPerformed = true; // Set the flag to true when a search is performed.
      }
    },
    setResults(results) {
      this.weather = results;
      this.errorMessage = ''; this.errorMessage = ''; // Clear the error message if the fetch is successful
    },
    dateBuilder() {
      let d = new Date();
      let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

      let day = days[d.getDay()];
      let date = d.getDate();
      let month = months[d.getMonth()];
      let year = d.getFullYear();

      return `${day} ${date} ${month} ${year}`;
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'montserrat', sans-serif;
}

#app {
  background-image: url('./assets/cold-bg.jpg');
  background-size: cover;
  background-position: bottom;
  transition: 0.4s;

}

#app .warm {
  background-image: url('./assets/warm.jpeg');
  background-size: cover;
  background-position: top;
}

#app .hot {
  background-image: url('./assets/sun.jpeg');
  background-size: cover;
  background-position: left;
}

#app .cold {
  background-image: url('./assets/snow.jpeg');
  background-size: cover;
  background-position: top;
}

.centered-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  text-shadow: 1px 3px rgba(0, 0, 0, 0.25);
}

main {
  min-height: 100vh;
  padding: 25px;

  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.75));
}

.search-box {
  width: 100%;
  margin-bottom: 30px;
}

.search-box .search-bar {
  display: block;
  width: 100%;
  padding: 15px;

  color: #313131;
  font-size: 20px;

  appearance: none;
  border: none;
  outline: none;
  background: none;

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  background-color: rgba(225, 225, 225, 0.75);
  border-radius: 0px 16px 0px 16px;
  transition: 0.4s;
}

.search-box .search-bar:focus {
  box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.25);
  background-color: rgba(225, 225, 225, 0.75);
  border-radius: 16px 0px 16px 0px;
}

.location-box .location {
  color: #fff;
  font-size: 32px;
  font-weight: 500;
  text-align: center;
  text-shadow: 1px 3px rgba(0, 0, 0, 0.25);
}

.location .date {
  color: #fff;
  font-size: 20px;
  font-weight: 300;
  font-style: italic;
  text-align: center;
}

.date{
  color: #000;
  font-size: 32px;
  font-weight: 300;
  font-style: italic;
  text-align: center;
  padding-top: 25px;
}

.weather-box {
  text-align: center;
}

.weather-box .temp {
  display: inline-block;
  padding: 10px 25px;
  color: #fff;
  font-size: 102px;
  font-weight: 900;

  text-shadow: 3px 6px rgba(0, 0, 0, 0.25);
  background-color: rgba(225, 225, 225, 0.25);
  border-radius: 16px;
  margin: 30px 0px;

  box-shadow: 3px 6px rgba(0, 0, 0, 0.25);
}

.weather-box .weather {
  color: #fff;
  font-size: 48px;
  font-weight: 700;
  font-style: italic;
  text-shadow: 3px 6px rgba(0, 0, 0, 0.25);
}

.card {
  /* color used to softly clip top and bottom of the .words container */
  --bg-color: #212121;
  background-color: var(--bg-color);
  padding: 1rem 2rem;
  border-radius: 1.25rem;
}

.loader {
  color: rgb(124, 124, 124);
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 25px;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  height: 40px;
  padding: 10px 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 8px;
}

.words {
  overflow: hidden;
  position: relative;
}

.words::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(var(--bg-color) 10%,
      transparent 30%,
      transparent 70%,
      var(--bg-color) 90%);
  z-index: 20;
}

.word {
  display: block;
  height: 100%;
  padding-left: 6px;
  color: #956afa;
  animation: spin_4991 8s infinite;
}

@keyframes spin_4991 {
  10% {
    -webkit-transform: translateY(-102%);
    transform: translateY(-102%);
  }

  25% {
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
  }

  35% {
    -webkit-transform: translateY(-202%);
    transform: translateY(-202%);
  }

  50% {
    -webkit-transform: translateY(-200%);
    transform: translateY(-200%);
  }

  60% {
    -webkit-transform: translateY(-302%);
    transform: translateY(-302%);
  }

  75% {
    -webkit-transform: translateY(-300%);
    transform: translateY(-300%);
  }

  85% {
    -webkit-transform: translateY(-402%);
    transform: translateY(-402%);
  }

  100% {
    -webkit-transform: translateY(-400%);
    transform: translateY(-400%);
  }
}





/* Media Queries for Responsiveness */
@media (max-width: 1200px) {
  .weather-box .temp {
    font-size: 80px;
  }

  .weather-box .weather {
    font-size: 40px;
  }

  .location-box .location {
    font-size: 28px;
  }

  .location .date {
    font-size: 18px;
  }

  .date {
    font-size: 28px;
  }

  .centered-text {
    font-size: 20px;
  }

  .loader {
    font-size: 20px;
  }

  .word {
    font-size: 20px;
  }

  .words {
    font-size: 20px;
  }

  .card {
    padding: 0.75rem 1.5rem;
  }
}

@media (max-width: 768px) {
  .weather-box .temp {
    font-size: 60px;
  }

  .weather-box .weather {
    font-size: 32px;
  }

  .location-box .location {
    font-size: 24px;
  }

  .location .date {
    font-size: 16px;
  }

  .search-box .search-bar {
    font-size: 18px;
    padding: 12px;
  }

  .date {
    font-size: 24px;
  }

  .centered-text {
    font-size: 18px;
  }

  .loader {
    font-size: 18px;
  }

  .word {
    font-size: 18px;
  }

  .words {
    font-size: 18px;
  }

  .card {
    padding: 0.5rem 1rem;
  }
}

@media (max-width: 480px) {
  .weather-box .temp {
    font-size: 40px;
  }

  .weather-box .weather {
    font-size: 24px;
  }

  .location-box .location {
    font-size: 20px;
  }

  .location .date {
    font-size: 14px;
  }

  .search-box .search-bar {
    font-size: 16px;
    padding: 10px;
  }

  .date {
    font-size: 20px;
  }

  .centered-text {
    font-size: 16px;
  }

  .loader {
    font-size: 16px;
  }

  .word {
    font-size: 16px;
  }

  .words {
    font-size: 16px;
  }

  .card {
    padding: 0.25rem 0.5rem;
  }
}

.error-message {
  color: red;
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
}
</style>
